"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChildrenInformationLimit;
(function (ChildrenInformationLimit) {
    ChildrenInformationLimit["NEED_COLLECTION_CHILDREN_INFORMATION"] = "0";
    ChildrenInformationLimit["UN_NEED_COLLECTION_CHILDREN_INFORMATION"] = "1";
})(ChildrenInformationLimit = exports.ChildrenInformationLimit || (exports.ChildrenInformationLimit = {}));
var Gender;
(function (Gender) {
    Gender[Gender["UNKNOWN"] = 0] = "UNKNOWN";
    Gender[Gender["MALE"] = 1] = "MALE";
    Gender[Gender["FEMALE"] = 2] = "FEMALE";
})(Gender = exports.Gender || (exports.Gender = {}));
var Constellation;
(function (Constellation) {
    Constellation[Constellation["AQUARIUS"] = 0] = "AQUARIUS";
    Constellation[Constellation["PISCES"] = 1] = "PISCES";
    Constellation[Constellation["ARIES"] = 2] = "ARIES";
    Constellation[Constellation["TAURUS"] = 3] = "TAURUS";
    Constellation[Constellation["GEMINI"] = 4] = "GEMINI";
    Constellation[Constellation["CANCER"] = 5] = "CANCER";
    Constellation[Constellation["LEO"] = 6] = "LEO";
    Constellation[Constellation["VIRGO"] = 7] = "VIRGO";
    Constellation[Constellation["LIBRA"] = 8] = "LIBRA";
    Constellation[Constellation["SCORPIO"] = 9] = "SCORPIO";
    Constellation[Constellation["SAGITTARIUS"] = 10] = "SAGITTARIUS";
    Constellation[Constellation["CAPRICORNUS"] = 11] = "CAPRICORNUS";
})(Constellation = exports.Constellation || (exports.Constellation = {}));
var Grade;
(function (Grade) {
    // 幼儿园 小班
    Grade[Grade["KINDERGARTEN_GRADE_1"] = 2000] = "KINDERGARTEN_GRADE_1";
    // 幼儿园 中班
    Grade[Grade["KINDERGARTEN_GRADE_2"] = 2010] = "KINDERGARTEN_GRADE_2";
    // 幼儿园 大班
    Grade[Grade["KINDERGARTEN_GRADE_3"] = 2020] = "KINDERGARTEN_GRADE_3";
    // 小学 一年级
    Grade[Grade["PRIMARY_SCHOOL_GRADE_1"] = 4000] = "PRIMARY_SCHOOL_GRADE_1";
    //  其他
    Grade[Grade["OTHER"] = 101000] = "OTHER";
})(Grade = exports.Grade || (exports.Grade = {}));
//# sourceMappingURL=child.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/child.js
// module id = 999
// module chunks = 0